<template>
  <div>
    <div class="modal is-active" v-show="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Remove Client as Active</p>
          <button class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
           Are you sure do you want to make {{client.companyName}} as <strong>"Inactive"</strong> client?
          <br/>
          <i>Note: Contact the developer if you want to permanently delete this.</i>
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button :class="dangerButton" @click="deleteUser">Yes</button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data() {
    return {
      dangerButton: appButton.isLoadingDanger(false)
    }
  },
  computed: {
    ...mapState('client', {
      showDeleteModal: state => state.showDeleteModal,
      client: state => state.client
    })
  },
  methods: {
    ...mapActions('client', ['openDeleteModal', 'getPaginatedClients']),
    deleteUser() {
      this.dangerButton = appButton.isLoadingDanger(true)
      axios
        .delete(`api/clients/${this.client.clientId}`)
        .then(response => {
          appToast.success(response.data)
          this.default()
        })
        .catch(error => {
          console.log(error)
          appToast.danger(
            'Something went wrong. Cannot delete client'
          )
        })
        .then(() => {
          this.dangerButton = appButton.isLoadingDanger(false)
        })
    },
    closeModal() {
      this.default()
    },
    default() {
      this.openDeleteModal({
        showDeleteModal: false
      })
      this.getPaginatedClients({
        page: 1,
        pageSize: 10,
        query: ''
      })
    }
  }
}
</script>
